export const livabilityKeys = {
  all: ['livability'] as const,
  apartments: (filters?: unknown, listingType?: string) =>
    [...livabilityKeys.all, 'apartments', filters, listingType] as const,
  filterOptions: (listingType?: string) =>
    [...livabilityKeys.all, 'filterOptions', listingType] as const,
  apartmentsInBounds: (params: unknown) =>
    [...livabilityKeys.all, 'apartmentsInBounds', params] as const,
  apartmentsByIds: (ids: number[], indexCategory?: string) =>
    [...livabilityKeys.all, 'apartmentsByIds', ids, indexCategory] as const,
  apartment: (id: number, includeIndex?: boolean, indexCategory?: string) =>
    [...livabilityKeys.all, 'apartment', id, includeIndex, indexCategory] as const,
  priceHistory: (apartmentId: number, sourceWebsite?: string) =>
    [...livabilityKeys.all, 'priceHistory', apartmentId, sourceWebsite] as const,
  apartmentSources: (apartmentId: number) =>
    [...livabilityKeys.all, 'apartmentSources', apartmentId] as const,
  nearbyPlaces: (apartmentId: number, radiusMeters: number) =>
    [...livabilityKeys.all, 'nearbyPlaces', apartmentId, radiusMeters] as const
}
